<template>
  <div class="asc-feature-flags-wrapper">
    <asc-feature-flags></asc-feature-flags>
  </div>
</template>

<script>
import AscFeatureFlags from '@/components/molecules/AscFeatureFlags'

export default {
  name: 'AscAdminWrapper',

  components: {
    AscFeatureFlags,
  },
}
</script>
